export const buildVariables: any = {"buildNumber":"20260717.1","buildDate":"2026-07-17 02:20:05-04:00","buildCommitMessage":"prevent WebKit empty-body multipart submits","svgSpritePath":"/assets/sprite/icons-5a984c11.svg"};
